import React, { useState, useEffect, useRef } from "react"
import { Button } from "./ui"
import Img from "gatsby-image"
import { ArrowRight } from "react-feather"

import Parallax from "../utils/parallax"
import { IndexPageQuery_oferta_edges_node } from "../pages/__generated__/IndexPageQuery"

type ItemPortfolioProps = {
    data: IndexPageQuery_oferta_edges_node
    even: boolean
    index?: number
    showIndex?: boolean
}
export const ItemPortfolio: React.FC<ItemPortfolioProps> = ({
    data,
    even,
    index = 0,
    showIndex = true,
}) => {
    const [state, changeState] = useState({
        animated: false,
        percentage: 0,
    })

    const getWindowHeight = () => {
        const w = window
        const d = document
        const e = d.documentElement
        const g = d.getElementsByTagName("body")[0]

        return w.innerHeight || e.clientHeight || g.clientHeight
    }

    const getWindowWidth = () => {
        const w = window
        const d = document
        const e = d.documentElement
        const g = d.getElementsByTagName("body")[0]

        return w.innerWidth || e.clientWidth || g.clientWidth
    }

    const updateState = p => changeState({ ...state, ...p })

    const percentageThreshold = 0.3

    let transform = useRef(0)

    useEffect(() => {
        transform.current =
            Math.min(getWindowHeight() / 2, 220) *
            Math.max(0, state.percentage - percentageThreshold)

        if (getWindowWidth() < 1024) {
            updateState({
                animated: true,
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.percentage])

    if (state.percentage > percentageThreshold && !state.animated)
        updateState({ animated: true })

    return (
        <Parallax changePercentage={updateState}>
            <div className="large-container">
                <div
                    className={`py-12 lg:py-24 portfolio-item lg:flex lg:items-center ${
                        state.animated ? "begin-animation" : ""
                    } ${even ? "even lg:flex-row-reverse" : ""}`}
                >
                    <div className="relative lg:w-7/12">
                        <div
                            className="image relative z-10"
                            style={{
                                transform: `translate(0px,${transform.current}px)`,
                            }}
                        >
                            <Img
                                fluid={
                                    data.frontmatter.image.childImageSharp.fluid
                                }
                                alt={data.frontmatter.title}
                            />
                        </div>
                    </div>
                    <div
                        className={`lg:w-5/12 mt-10 lg:mt-0 ${
                            even ? "lg:pr-16" : "lg:pl-16"
                        }`}
                    >
                        {showIndex && (
                            <p className="item-index to-up">
                                {String(index + 1).padStart(2, "0")}
                            </p>
                        )}
                        <h3 className="display-2 text-color-1 to-up">
                            {data.frontmatter.title}
                        </h3>
                        <p className="mt-6 text-color-2 to-up">
                            {data.frontmatter.description}
                        </p>
                        <div className="mt-10 to-up">
                            <Button
                                to={data.fields.slug}
                                variant="ghost"
                                label={`Czytaj więcej — ${data.frontmatter.title}`}
                                title="Zobacz szczegóły"
                                iconRight={<ArrowRight />}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Parallax>
    )
}

export default ItemPortfolio
